import {debug} from "../utils";

export const ACTION_SIDEBAR_VIEW_CHANGED = "ACTION_SIDEBAR_VIEW_CHANGED";
export const ACTION_SET_PAGE_TITLE = "ACTION_SET_PAGE_TITLE";
export const ACTION_BREADCRUMBS_CHANGED = "ACTION_BREADCRUMBS_CHANGED";

export function LayoutReducer(state = {sidebarCollapsed: true}, action) {
    switch (action.type) {
        case ACTION_SIDEBAR_VIEW_CHANGED: {
            debug(`LayoutReducer ${ACTION_SIDEBAR_VIEW_CHANGED} is being processed...`)
            return {
                ...state,
                sidebarCollapsed: !state.sidebarCollapsed
            }
        }
        case ACTION_SET_PAGE_TITLE: {
            debug(`LayoutReducer ${ACTION_SET_PAGE_TITLE} is being processed...`)
            return {
                ...state,
                pageTitle: action.payload.pageTitle
            }
        }
        case ACTION_BREADCRUMBS_CHANGED: {
            debug(`LayoutReducer ${ACTION_BREADCRUMBS_CHANGED} is being processed...`)
            return {
                ...state,
                breadcrumbs: action.payload.breadcrumbs
            }
        }
        default:
            return state;
    }
}
